import React from 'react';
import {
  BulletList,
  Card,
  RelatedLinks,
  ResultNote,
  useGuideTheme,
} from './guideBlocks';

const FreePro: React.FC = () => {
  const { heroPrimary, heroSecondary } = useGuideTheme();
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card>
          <h3 className="text-lg font-bold mb-4" style={{ color: heroPrimary }}>Free</h3>
          <BulletList items={[
            'Host up to 3 active events at a time',
            'Keep up to 3 motorcycles in your garage',
            'Set rider-experience and engine-size requirements',
            'Join events, chat, check in, and ride with the community',
          ]} />
        </Card>
        <Card>
          <h3 className="text-lg font-bold mb-4" style={{ color: heroPrimary }}>Pro</h3>
          <BulletList items={[
            'Host unlimited active events',
            'Keep up to 5 motorcycles in your garage',
            'Route waypoints (iOS), expanded sponsor capacity and premium themes',
            'GroupPulse live tracking on the events you host',
          ]} />
          <p className="text-xs mt-4" style={{ color: heroSecondary }}>
            See the upgrade screen in the app for current pricing and availability.
          </p>
        </Card>
      </div>
      <div className="mt-8 max-w-2xl">
        <h3 className="text-xl font-bold mb-3" style={{ color: heroPrimary }}>Two different limits</h3>
        <p className="text-sm leading-relaxed mb-4" style={{ color: heroSecondary, textWrap: 'pretty' }}>
          <span className="font-semibold" style={{ color: heroPrimary }}>Active-event limit (your plan).</span>{' '}
          Events that haven't finished or been cancelled count as active. Completed or cancelled events no longer count toward your active-event limit. Free accounts host up to 3; Pro hosts can run unlimited active events.
        </p>
        <p className="text-sm leading-relaxed" style={{ color: heroSecondary, textWrap: 'pretty' }}>
          <span className="font-semibold" style={{ color: heroPrimary }}>Daily activity limits (every account).</span>{' '}
          Separate from your plan, creating and joining events have per-day caps that start lower for new accounts and increase as the account ages: creation starts at 2 per day and rises to 6, joining starts at 5 per day and rises to 15. These apply to Pro accounts too. Activity limits ease as earlier actions leave the time window. Follow the retry timing shown in the app.
        </p>
      </div>
      <ResultNote>Unlimited covers active-event hosting only. Daily activity limits still apply to every account.</ResultNote>
      <RelatedLinks links={[
        { id: 'create-event', label: 'Create an event' },
        { id: 'grouppulse', label: 'GroupPulse' },
      ]} />
    </>
  );
};

export default FreePro;
